import { render, staticRenderFns } from "./CancelPresentation.vue?vue&type=template&id=21ff08ca&functional=true&"
import script from "./CancelPresentation.vue?vue&type=script&lang=js&"
export * from "./CancelPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports